// extracted by mini-css-extract-plugin
export default {"content":"XH-z"};